/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const CUSTOMER_BASE_LINK = '/admin/customers'

export function getCustomerCreateLink () {
  return `${CUSTOMER_BASE_LINK}/create`
}

export function getCustomerLink (id: number | string) {
  return `${CUSTOMER_BASE_LINK}/${id}/edit`
}

export function getCustomerEstateListLink (id: number | string) {
  return `${CUSTOMER_BASE_LINK}/${id}/estates`
}

export function getCustomerLeaseListLink (id: number | string) {
  return `${CUSTOMER_BASE_LINK}/${id}/leases`
}

export function getCustomerMandateListLink (id: number | string) {
  return `${CUSTOMER_BASE_LINK}/${id}/mandates`
}

export function getCustomerProspectingListLink (id: number | string) {
  return `${CUSTOMER_BASE_LINK}/${id}/prospecting`
}

export function getCustomerReportLink (id: number | string) {
  return `${CUSTOMER_BASE_LINK}/${id}/reports`
}

export function getCustomerListLink () {
  return CUSTOMER_BASE_LINK
}
